import Vue from "vue";
import AbstractGenLex, { GenLexWithLabel, GenLexWithLibelle } from '../models/abstract-gen-lex';
import moment from "moment";

moment.locale("fr");

/**
 * Traverse the DOM tree from element to root nodes until predicateFn evaluates to true.
 *
 * returns:
 * - element in iteration when predicateFn evalutes on true
 * - null (documentElement.parent)if predicateFn never evaluates to true
 */
export const walkUpUntil = (element, predicateFn) => {
  let currentEl = element
  do {
    if (currentEl.nodeType === Node.ELEMENT_NODE && predicateFn(currentEl)) {
      break
    }
  } while (currentEl = currentEl.parentNode)
  return currentEl
}


export const newUid = (function* _newUid() {
  for (let start = new Date().getTime(); ;) {
    yield (++start).toString(36);
  }
})();

export const arrDiff = (prev, next, keyFn) => {
  return [...(next || []).reduce((out, r) => {
    out.set(keyFn(r), out.has(keyFn(r)) ? [1, r] : [2, r]);
    return out;
  }, new Map((prev || []).map(r => [keyFn(r), [0, r]])))
    .values()].reduce((out, [v, o]) => {
      out[["removed", "unchanged", "added"][v]].push(o);
      return out;
    }, { removed: [], unchanged: [], added: [] });
}

export const detectMixin = (node: Vue, clazz: Function): boolean => {
  return node && (node.constructor as any).options.components[clazz.name];
}

type LexLabelOptions<T> = {
  noValueStr?: string;
  labelField?: keyof T;
}
export const lexLabel = <T>(l: T, opts: LexLabelOptions<T> = {}): string => {
  let lf;
  if (l instanceof GenLexWithLibelle) {
    lf = "libelle";
  } else {
    lf = opts.labelField as string || "label";
  }
  return (l && l[lf]) || opts.noValueStr;
}

export const ellipsis = (txt: string, lgt: number) => {
  txt = txt || "";
  return txt.length > lgt ?
    txt.slice(0, lgt-1) + "…"
    : txt;
};

export const formatDate = (date, format = "DD/MM/YYYY") => (date && moment(date).format(format)) || "";

export const strEqNoCase = (a, b) => a && b && a.toLowerCase() === b.toLowerCase();
export const strCompare = (a, b) => a && b ? a.localeCompare(b) : (a && 1) || -1;

export const notEmpty = (v: string | number | object | Array<any> | Date) => {
  if (typeof v === "string" || v instanceof Array) return v.length > 0;
  return v != null;
};

export const loadingClass = (...loadingCnts: (number | boolean)[]): string => loadingCnts.every(Boolean) ? 'is-loading' : '';

/* return the value at path */
export const $get = (o, path) => path.split(/\./g).reduce((out, p) => (out && out[p]), o);